export function truncateLabel(text: string, maxLength: number): string {
  if (text.length <= maxLength) {
    return text;
  }
  return `${text.slice(0, maxLength).trimEnd()}…`;
}

export function splitFileName(fileName: string): { base: string; extension: string } {
  const lastDotIndex = fileName.lastIndexOf('.');
  const hasExtension = lastDotIndex > 0 && lastDotIndex < fileName.length - 1;

  if (!hasExtension) {
    return { base: fileName, extension: '' };
  }

  return { base: fileName.slice(0, lastDotIndex), extension: fileName.slice(lastDotIndex) };
}
